import { select } from "@assets/scripts/utils";
import { scrollTo } from "@assets/scripts/utils";

export function scroller(selector, options = {}) {
    const elements = select(selector)
    elements.forEach(element => {
        element.addEventListener('click', function (e) {
            e.preventDefault()
            const target = this.getAttribute('data-scroll-to')
            const type = Number(target)
            let offset = Number.isNaN(type) ? document.querySelector(target).offsetTop : Number(target)
            scrollTo(offset)
        })
    })
    return elements
}

export default { scroller }
